<template>
  <div class="button__webshop fixed z-4 top-vh-100-circle right-0">
    <a
      :href="shop.url"
      :class="darkTheme == 'dark' ? 'dark' : 'white'"
      class="db btn-circle"
      :ref="`ButtonCircleRotating`"
    >{{ shop.buttonLabel }}</a>
  </div>
</template>

<script>
import CircleType from "circletype"
import s from "../store"

export default {
  name: "ButtonCircleRotating",

  props: {
    shop: Object,
    darkTheme: {
      type: String,
      default: "white"
    }
  },

  data() {
    return {
      sharedState: s.state,
      circle: null
    }
  },
  mounted() {
    this.initCircleType()
  },

  methods: {
    initCircleType: function() {
      this.circle = new CircleType(this.$refs.ButtonCircleRotating)
      this.circle.refresh()

      this.$refs.ButtonCircleRotating.parentElement.style.paddingRight =
        this.circle.radius() / 2 + "px"

      this.$refs.ButtonCircleRotating.parentElement.style.width =
        this.circle.radius() + "px"
      this.$refs.ButtonCircleRotating.parentElement.style.height =
        this.circle.radius() + "px"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button__webshop {
  margin-right: 8.33333%;
}
.top-vh-100-circle {
  top: calc(100vh - 350px);
}

.btn-circle {
  font-size: 1.375rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  animation-name: rotate;
  animation-duration: 60s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.btn-circle:hover {
  animation-play-state: paused;
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
